module.exports = __webpack_public_path__ + "img/icon_time.811d06d7.svg";